import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { UncontrolledCollapse } from "reactstrap";
import { FaAngleLeft, FaPlusCircle } from "react-icons/fa";

import ConstData from "../../../lib/ConstData";

import WebCreateUsers from "./WebCreateUsers";
import WebConfigMemberInfo from "../list/WebConfigMemberInfo";
import WebUserLoginResetAlertModal from "../modal/WebUserLoginResetAlertModal";
import WebUserPWResetAlertModal from "../modal/WebUserPWResetAlertModal";
import WebSubDomainConfigAdminUserAlertModal from "../modal/WebSubDomainConfigAdminUserAlertModal";
import WebSubDomainCreateAdminUserAlertModal from "../modal/WebSubDomainCreateAdminUserAlertModal";
import WebWarningAlertModal from "../modal/WebWarningAlertModal";
import WebUserStatus from "../../etc/list/WebUserStatus";
import WebPagination from "../../etc/WebPagination";

const WebSubDomainDetailInfo = ({ userSeq, userKind, isStandardType, subDomain_info, handleSelectedFunc }) => {
    const { t } = useTranslation();

    const [list, setList] = useState([]);

    // 한 페이지에 보여줄 개수 (10/20/30/50/100 선택 가능)
    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(1);
    const [offset, setOffset] = useState((page - 1) * limit);
    const [blockNum, setBlockNum] = useState(0);

    // 컴포넌트 초기 로드 여부를 추적하는 상태 추가
    const [isFirstLoad, setIsFirstLoad] = useState(true);

    const [isUserResetStatusModalOpened, setIsUserResetStatusModalOpened] = useState(false);
    const [isPWResetStatusModalOpened, setIsPWResetStatusModalOpened] = useState(false);
    const [isConfigAdminModalOpened, setIsConfigAdminModalOpened] = useState(false);
    const [isCreateAdminModalOpened, setIsCreateAdminModalOpened] = useState(false);
    const [isWarningAlertOpened, setIsWarningAlertOpened] = useState(false);
    const [lWarningKind, setWarningKind] = useState("");

    const [selectedMemberInfo, setSelectedMemberInfo] = useState({
        mode: "",
        subDomainSeq: -1,
        subDomainName: "",
        userSeq: -1,
        userNickname: "",
        userProfile: "",
        profileImgUrl: "",
        isConfigAdmin: false,
        isCreateAdmin: false
    });

    const [isOpened, setIsOpened] = useState(false);

    const enterTimeRef = useRef(0);
    const exitTimeRef = useRef(0);

    const toggleRef = useRef(null);

    useEffect(() => {
        // console.log("WebSubDomainDetailInfo visible");

        return () => {
            // console.log("WebSubDomainDetailInfo invisible");

            // 컴포넌트가 언마운트될 때 초기화
            setIsFirstLoad(true);
        }
    }, []);

    useEffect(() => {
        if (subDomain_info.list_member) {
            setList(subDomain_info.list_member);
        }    
    }, [subDomain_info.list_member]);

    useEffect(() => {
        if (subDomain_info.list_createUser) {
            toggleRef.current.updateCreateUsers(subDomain_info.list_createUser);
        }
    }, [subDomain_info.list_createUser]);

    useEffect(() => {
        let offset = (page - 1) * limit;
        console.log(`page[${page}], offset[${offset}]`);
        setOffset(offset);
    }, [page, limit]);

    const toggleModalOpened = (isModalOpened, mode, subDomainSeq, memberInfo, userStatus) => {
        if (userStatus !== ConstData.LOGIN_STATUS.LOG_OUT) {
            if (mode === "web" && memberInfo !== undefined && memberInfo !== null && memberInfo.userSeq === userSeq) {
                console.log("웹에서 자기 자신을 로그아웃할 수 없음!!!!");
                toggleWarningAlertModalOpened(true, "RESET_USER_STATUS");
            } else {
                if (isModalOpened) {
                    setSelectedMemberInfo({
                        ...selectedMemberInfo,
                        mode,
                        subDomainSeq,
                        subDomainName: "",
                        userSeq: memberInfo.userSeq,
                        userNickname: memberInfo.userNickname,
                        userProfile: memberInfo.userProfile,
                        profileImgUrl: memberInfo.profileImgUrl,
                        isConfigAdmin: memberInfo.isConfigAdmin
                    });
                } else {
                    setSelectedMemberInfo({
                        mode: "",
                        subDomainSeq: -1,
                        subDomainName: "",
                        userSeq: -1,
                        userNickname: "",
                        userProfile: "",
                        profileImgUrl: "",
                        isConfigAdmin: false,
                        isCreateAdmin: false
                    });
                }

                setIsUserResetStatusModalOpened(isModalOpened);
            }
        } else {
            console.log("toggleModalOpened() userStatus is LOG_OUT");
        }
    }

    const togglePWModalOpened = (isModalOpened, subDomainSeq, memberInfo) => {
        if (memberInfo !== undefined && memberInfo !== null && memberInfo.userSeq === userSeq) {
            console.log("자기 자신의 비밀번호는 회원정보 수정을 이용해야함!!!!");
            toggleWarningAlertModalOpened(true, "RESET_USER_PW");
        } else {
            if (isModalOpened) {
                setSelectedMemberInfo({
                    ...selectedMemberInfo,
                    mode: "",
                    subDomainSeq,
                    subDomainName: "",
                    userSeq: memberInfo.userSeq,
                    userNickname: memberInfo.userNickname,
                    userProfile: memberInfo.userProfile,
                    profileImgUrl: memberInfo.profileImgUrl,
                    isConfigAdmin: memberInfo.isConfigAdmin
                });
            } else {
                setSelectedMemberInfo({
                    mode: "",
                    subDomainSeq: -1,
                    subDomainName: "",
                    userSeq: -1,
                    userNickname: "",
                    userProfile: "",
                    profileImgUrl: "",
                    isConfigAdmin: false,
                    isCreateAdmin: false
                });
            }

            setIsPWResetStatusModalOpened(isModalOpened);
        }
    }

    const toggleCreateSubDomainAdminModalOpened = (isModalOpened, subDomainSeq, subDomainName, memberInfo) => {
        if (memberInfo !== undefined && memberInfo !== null && memberInfo.userSeq === userSeq) {
            toggleWarningAlertModalOpened(true, "SUB_DOMAIN_CREATE_ADMIN");
        } else {
            if (isModalOpened) {
                setSelectedMemberInfo({
                    ...selectedMemberInfo,
                    mode: "",
                    subDomainSeq,
                    subDomainName,
                    userSeq: memberInfo.userSeq,
                    userNickname: memberInfo.userNickname,
                    userProfile: memberInfo.userProfile,
                    profileImgUrl: memberInfo.profileImgUrl,
                    isCreateAdmin: memberInfo.isCreateAdmin
                });
            } else {
                setSelectedMemberInfo({
                    mode: "",
                    subDomainSeq: -1,
                    subDomainName: "",
                    userSeq: -1,
                    userNickname: "",
                    userProfile: "",
                    profileImgUrl: "",
                    isConfigAdmin: false,
                    isCreateAdmin: false
                });
            }

            setIsCreateAdminModalOpened(isModalOpened);
        }
    }

    const toggleSubDomainAdminModalOpened = (isModalOpened, subDomainSeq, subDomainName, memberInfo) => {
        if (memberInfo !== undefined && memberInfo !== null && memberInfo.userSeq === userSeq) {
            toggleWarningAlertModalOpened(true, "SUB_DOMAIN_ADMIN");
        } else {
            if (isModalOpened) {
                setSelectedMemberInfo({
                    ...selectedMemberInfo,
                    mode: "",
                    subDomainSeq,
                    subDomainName,
                    userSeq: memberInfo.userSeq,
                    userNickname: memberInfo.userNickname,
                    userProfile: memberInfo.userProfile,
                    profileImgUrl: memberInfo.profileImgUrl,
                    isConfigAdmin: memberInfo.isConfigAdmin
                });
            } else {
                setSelectedMemberInfo({
                    mode: "",
                    subDomainSeq: -1,
                    subDomainName: "",
                    userSeq: -1,
                    userNickname: "",
                    userProfile: "",
                    profileImgUrl: "",
                    isConfigAdmin: false,
                    isCreateAdmin: false
                });
            }

            setIsConfigAdminModalOpened(isModalOpened);
        }
    }

    const toggleWarningAlertModalOpened = (isModalOpened, warningKind) => {
        if (isModalOpened) {
            setWarningKind(warningKind);
        } else {
            setWarningKind("");
        }

        setIsWarningAlertOpened(isModalOpened);
    }

    const onClickResetUserStatus = (mode, subDomainSeq, userSeq) => {
        handleSelectedFunc({ selectedFunc: "RESET_USER_STATUS", selectedUserSeq: userSeq, subDomainSeq, mode });
        setIsUserResetStatusModalOpened(false);
    }

    const onClickResetUserPW = (subDomainSeq, userSeq, password) => {
        handleSelectedFunc({ selectedFunc: "RESET_USER_PW", selectedUserSeq: userSeq, subDomainSeq, password });
        setIsPWResetStatusModalOpened(false);
    }

    const onClickConfigAdminIcon = (subDomainSeq, memberInfo) => {
        if (memberInfo !== undefined && memberInfo !== null && memberInfo.isConfigAdmin) {
            handleSelectedFunc({ selectedFunc: "REMOVE_SUB_DOMAIN_ADMIN", subDomainSeq, selectedUserSeq: memberInfo.userSeq });
        } else {
            handleSelectedFunc({ selectedFunc: "ADD_SUB_DOMAIN_ADMIN", subDomainSeq, selectedUserSeq: memberInfo.userSeq });
        }

        setIsConfigAdminModalOpened(false);
    }

    const onClickCreateAdminIcon = (subDomainSeq, memberInfo) => {
        if (memberInfo !== undefined && memberInfo !== null && memberInfo.isCreateAdmin) {
            handleSelectedFunc({ selectedFunc: "REMOVE_CREATE_SUB_DOMAIN_ADMIN", subDomainSeq, selectedUserSeq: memberInfo.userSeq });
        } else {
            handleSelectedFunc({ selectedFunc: "ADD_CREATE_SUB_DOMAIN_ADMIN", subDomainSeq, selectedUserSeq: memberInfo.userSeq });
        }

        setIsCreateAdminModalOpened(false);
    }

    const onClickAddNewUsers = () => {

    }

    const goToPassListPage = ({ subDomainSeq }) => {
        if (subDomainSeq === 1) {
            handleSelectedFunc({ selectedFunc: "GET_PCHS_LIST", kind: "USER", subDomainSeq, selectedUserSeq: userSeq });
        } else {
            handleSelectedFunc({ selectedFunc: "GET_PCHS_LIST", kind: "SUB_DOMAIN", subDomainSeq });
        }
    }

    const onEnteringEvent = () => {
        enterTimeRef.current = Date.now();
        console.log("onEnteringEvent - ", enterTimeRef.current);
        //setIsOpened(true);
    }

    const onEnteredEvent = () => {
        let enteredTime = Date.now() - enterTimeRef.current;
        console.log("onEnteredEvent - ", enteredTime);
        setIsOpened(true);
    }

    const onExitingEvent = () => {
        exitTimeRef.current = Date.now();
        console.log("onExitingEvent - ", exitTimeRef.current);
        if (toggleRef.current) {
            toggleRef.current.updateCreateUsers([
                {
                    userID: "",
                    userPW: "",
                    userNickname: "",
                    userProfile: "",
                    isIdCheckOK: false,
                    isJoinSuccess: false,
                    isExist: false,
                    userSeq: -1,
                    errMsg: ""
                }
            ]);
        }
        setIsOpened(false);
    }

    const onExitedEvent = ()=> {
        let exitedTime = Date.now() - exitTimeRef.current;
        console.log("onExitedEvent - ", exitedTime);
        setIsOpened(false);
    }

    return (
        // teacher/class 탭과 동일한 app-container / list-table 스타일 적용
        // (기존 로직·핸들러·props는 그대로 유지, 마크업/className만 교체)
        // 주의: display:flex 클래스(landscape-to-portrait 등)는 td가 아니라 td 내부 div에 적용해야
        // table-cell 박스가 깨지지 않고 열 정렬이 유지됨
        <div className="web-main admin list-area">
            <div className="app-container">
                <div className="d-flex my-2">
                    <button type="button" className="d-flex hiclasstv-btn b-none rounded align-items-center py-1 black-text" title="서브 도메인 목록 보기" onClick={() => handleSelectedFunc({ selectedFunc: "GOTO_SUB_DOMAIN_HOME" })}>
                        <FaAngleLeft className="d-flex m-1" />
                        <span className="small">{t("목록으로", { ns: "admin" })}</span>
                    </button>
                </div>

                {/* 서브 도메인 요약 정보 (1행짜리 list-table) */}
                {/* 260804-7 서브 도메인 이름 말줄임(...) 실제 동작을 위해 table-layout:fixed 적용 */}
                <div className="table-container">
                    <table className="list-table admin-ellipsis-table">
                        <thead>
                            <tr>
                                <th style={{ width: '35%' }} className="text-center">{t("서브_도메인_이름", { ns: "admin" })}</th>
                                <th style={{ width: '40%' }} className="text-center">
                                    <div className="only-web w-100">
                                        <span className="area-60">{t("접속현황", { ns: "admin" })}</span>
                                        <span className="area-40">{t("멤버", { ns: "common" })}</span>
                                    </div>
                                    <div className="only-mobile w-100" style={{ justifyContent: 'center' }}>
                                        {t("사용자", { ns: "admin" })}
                                    </div>
                                </th>
                                <th style={{ width: '25%' }} className="text-center">
                                    <div className="only-web w-100">
                                        <span className="area-50">{t("팀업", { ns: "chat" })}</span>
                                        <span className="area-50">{t("클래스", { ns: "live" })}</span>
                                    </div>
                                    <div className="only-mobile w-100">
                                        {t("팀업", { ns: "chat" })}/{t("클래스", { ns: "live" })}
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className="text-center">
                                    {/* 260804 서브 도메인 이름 말줄임(...) 처리 - text-area(display:contents)가
                                        폭 제약을 못 걸어주던 걸 flex 셀(admin-ellipsis-cell)로 수정 */}
                                    <div className="d-flex align-items-center justify-content-center admin-ellipsis-cell">
                                        <span className="info title hiclass-text admin-ellipsis-text" title={subDomain_info.subDomainName}>{subDomain_info.subDomainName}</span>
                                    </div>
                                </td>
                                <td className="small text-center">
                                    <div className="landscape-to-portrait">
                                        <div className="list-row justify-content-center area-60">
                                            <WebUserStatus kind={"userStatus"} list_member={subDomain_info.list_member} />
                                        </div>
                                        <div className="list-row justify-content-center area-40">
                                            <div className="add-btn-area">
                                                <button type="button" id="addNewUsers" className="hiclasstv-btn-transparent hiclasstv-blue-text p-0">
                                                    <FaPlusCircle className="font-lg" />
                                                    <span className="font-weight-bold ml-2">{t("사용자_추가", { ns: "admin" })}</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                                <td className="small text-center">
                                    <div className="landscape-to-portrait">
                                        <div className="list-row area-50">
                                            <span className="only-mobile">T :&nbsp;</span>{subDomain_info.chatRoomCnt}
                                        </div>
                                        <div className="list-row area-50">
                                            <span className="only-mobile">L :&nbsp;</span>
                                            {
                                                subDomain_info.liveOnCnt > 0 ?
                                                    <span className="green-text font-weight-bold">{subDomain_info.liveOnCnt}</span> :
                                                    <span>{subDomain_info.liveOnCnt}</span>
                                            }
                                            <span>&nbsp;{" / " + subDomain_info.liveCnt}</span>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                {/* 사용자 추가 폼(펼침) - 기존 WebCreateUsers 로직/스타일 그대로 유지 */}
                <UncontrolledCollapse toggler="#addNewUsers" defaultOpen={false} onEntered={onEnteredEvent} onEntering={onEnteringEvent} onExiting={onExitingEvent} onExited={onExitedEvent}>
                    <WebCreateUsers
                        ref={toggleRef}
                        subDomainSeq={subDomain_info.subDomainSeq}
                        handleSelectedFunc={handleSelectedFunc}
                    />
                </UncontrolledCollapse>

                <WebPagination
                    total={subDomain_info.list_member.length}
                    limit={limit}
                    setLimit={setLimit}
                    page={page}
                    setPage={setPage}
                    blockNum={blockNum}
                    setBlockNum={setBlockNum}
                />

                {/* 멤버 목록 (list-table) */}
                {/* 260804-7 닉네임 말줄임(...) 실제 동작을 위해 table-layout:fixed 적용 */}
                <div className="table-container">
                    <table className="list-table admin-ellipsis-table">
                        <thead>
                            <tr>
                                <th style={{ width: '40%' }} className="text-center">{t("닉네임", { ns: "user" })}</th>
                                <th style={{ width: '25%' }} className="text-center">{t("상태", { ns: "common" })}</th>
                                <th style={{ width: '35%' }} className="text-center">
                                    <div className="only-web w-100">
                                        <span className="area-50">{t("마지막_로그인_시간", { ns: "admin" })}</span>
                                        <span className="area-50">{t("가입일", { ns: "admin" })}</span>
                                    </div>
                                    <div className="only-mobile w-100" style={{ justifyContent: 'center' }}>
                                        {t("접속시간", { ns: "admin" })}/{t("가입일", { ns: "admin" })}
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                list && list.length > 0 ?
                                    list.slice(offset, offset + limit).map(member => (
                                        <WebConfigMemberInfo
                                            key={"config-" + subDomain_info.subDomainSeq + "-member-" + member.userSeq}
                                            userKind={userKind}
                                            subDomain_info={subDomain_info}
                                            member_info={member}
                                            toggleModalOpened={toggleModalOpened}
                                            togglePWModalOpened={togglePWModalOpened}
                                            toggleSubDomainAdminModalOpened={toggleSubDomainAdminModalOpened}
                                            toggleCreateSubDomainAdminModalOpened={toggleCreateSubDomainAdminModalOpened}
                                        />
                                    )) :
                                    <tr>
                                        <td colSpan={3} className="text-center" style={{ color: '#aaaaaa', padding: '24px 0' }}>
                                            {t("관리_가능한_회원_목록_없음", { ns: "admin" })}
                                        </td>
                                    </tr>
                            }
                        </tbody>
                    </table>
                </div>
            </div>
            {
                isUserResetStatusModalOpened &&
                <WebUserLoginResetAlertModal
                    isModalOpened={isUserResetStatusModalOpened}
                    selectedMemberInfo={selectedMemberInfo}
                    toggleModalOpened={toggleModalOpened}
                    onClickResetUserStatus={onClickResetUserStatus}
                />
            }
            {
                isPWResetStatusModalOpened &&
                <WebUserPWResetAlertModal
                    isModalOpened={isPWResetStatusModalOpened}
                    selectedMemberInfo={selectedMemberInfo}
                    toggleModalOpened={togglePWModalOpened}
                    onClickResetUserPW={onClickResetUserPW}
                />
            }
            {
                isConfigAdminModalOpened &&
                <WebSubDomainConfigAdminUserAlertModal
                    isModalOpened={isConfigAdminModalOpened}
                    selectedMemberInfo={selectedMemberInfo}
                    toggleModalOpened={toggleSubDomainAdminModalOpened}
                    onClickAdminIcon={onClickConfigAdminIcon}
                />
            }
            {
                isCreateAdminModalOpened &&
                <WebSubDomainCreateAdminUserAlertModal
                    isModalOpened={isCreateAdminModalOpened}
                    selectedMemberInfo={selectedMemberInfo}
                    toggleModalOpened={toggleCreateSubDomainAdminModalOpened}
                    onClickAdminIcon={onClickCreateAdminIcon}
                />
            }
            {
                isWarningAlertOpened &&
                <WebWarningAlertModal
                    isModalOpened={isWarningAlertOpened}
                    warningKind={lWarningKind}
                    toggleModalOpened={toggleWarningAlertModalOpened}
                />
            }
        </div>
    );
}

export default WebSubDomainDetailInfo;